import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IWebviewService = ( createDecorator('webviewService'));
export { IWebviewService };
